@if (visibleMenus?.length) {
  <div class="sub-menu pb-5" [class.hide]="hideSubMenu">
    <ul class="list-group">
      @for (menu of visibleMenus; track trackByFn($index, menu)) {
        <li
          class="list-group-item list-group-item-action"
          routerLinkActive="active"
          [routerLink]="menu.routerLink"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="handleClick(menu)">
          {{ menu.label | translate | uppercase }}
          @if (menu.icon) {
            <i [class]="menu.icon"></i>
          }
        </li>
      }
    </ul>
  </div>
}
